import CustomTable, {TypeItemTable} from "../../../components/general/CustomTable";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Person} from "../../../services/interface/query/person";
import {PaginationPersonTree} from "../../../services/interface/query/paginationPersonTree";
import {PersonTree} from "../../../services/interface/query/personTree";
import {getAge} from "../../../utils/personOptions";
import IdentificationConsult from "../../terms-conditions/IdentificationConsult";
import {useFindFamilyTree} from "../../../services/apis/apiGenomePerson";
import {getMessageGeneric} from "../../../services/configuration/errorHandle";

interface Props {
    person?: Person;
}
export default function AdditionalFamily({person}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: getFamilyTree,
        data: successPersonFamilyTree,
        error: errorPersonFamilyTree,
        isPending: loadingPersonFamilyTree
    } = useFindFamilyTree()

    const header = [
        t('identification'),
        t('names'),
        t('phone'),
        t('age'),
        t('relationship'),
        t('description'),
    ];
    const [list, setList] = useState<PaginationPersonTree | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()
    const [index, setIndex] = useState<number | undefined>()

    useEffect(() => {
        if (person && person.identification) {
            setList(undefined)
            setListElement(undefined)
            getFamilyTree({identifier: person.identification, page: 0, msj: t('additional-relationships')})
        }
    }, [person]);

    useEffect(() => {
        if (successPersonFamilyTree) {
            setList(successPersonFamilyTree)
            const listAux: TypeItemTable[] = []
            successPersonFamilyTree.content?.forEach((item: PersonTree) => {
                listAux.push(
                    {
                        row: [
                        <IdentificationConsult
                            className={'text-header text-[14px] pl-2'}
                            identification={item?.personDto?.identification}
                        />,
                        item?.personDto?.names,
                        item?.personDto?.phone,
                        getAge(item?.personDto?.dateOfBirth),
                        item?.relationship?.descRelationship,
                        item?.relationship?.descriptionRelationship]
                    }
                )
            })
            setListElement(listAux)
        }
    }, [successPersonFamilyTree]);

    useEffect(() => {
        if ((index || index === 0) && person?.identification) {
            getFamilyTree({identifier: person.identification, page: index})
        }
    }, [index]);

    return(
        <div>
            <h3>{t('additional-relationships')}</h3>
            <CustomTable
                error={getMessageGeneric(errorPersonFamilyTree, '/information/family/tree')}
                loading={loadingPersonFamilyTree}
                pagination={true}
                header={header}
                number={list?.number}
                totalPages={list?.totalPages}
                totalElements={list?.totalElements}
                {...{listElement, setIndex}}
            />
        </div>
    )
}
